/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import {
  OfficeRolePermissionTreeDto,
  OfficeRoleTodoPermissionsDto,
} from './office-role-permission-tree.dto';

export const OfficeRolePermissionTreeMapper = entity<OfficeRolePermissionTreeDto>();
export const OfficeRoleTodoPermissionMapper = entity<OfficeRoleTodoPermissionsDto>({});
